import { FC } from "react";
import styles from "./NewItemIcon.module.css";

const NewItemIcon: FC = () => <span className={styles.icon}>*</span>;

export default NewItemIcon;
